const { BaseClient, setupClient } = require('./base-client')

const { v1Url } = require('sci/utils')

class V1Client extends BaseClient {
    url (path) {
        return v1Url(path)
    }
}

module.exports = setupClient(V1Client)



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/v1Client.js